import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchCompany, postCompanyConfigure, fetchCompanyRegistrar } from "../actions/index";
import { Button } from "react-bootstrap";
import { CSSTransitionGroup } from 'react-transition-group';
import * as Constants from '../constants';

class CompanyStatus extends Component {
  static propTypes = {
    fetchCompany: PropTypes.func.isRequired,
    postCompanyConfigure: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    company: PropTypes.object,
    fetchCompanyRegistrar: PropTypes.func.isRequired,
    registrar: PropTypes.object
  };

  getInitialState() {
    return {
      showStatusUpdating: false,
      showStatusNotReady: false
    };
  }

  componentDidMount() {
    this.props.fetchCompany().then(company => {
      const status = company.payload.data.data.status;
      if (status == "using_other_nameservers") {
        this.props.fetchCompanyRegistrar();
      }
    });
  }

  configure() {
    this.setState({ showStatusUpdating: true });
    this.props
      .postCompanyConfigure()
      .then(() => {
        setTimeout(this.proceedIfEnabled.bind(this), 8000);
      });
  }

  proceedIfEnabled() {
    this.props.fetchCompany().then(response => {
      let status = response.payload.data.data.status;
      if (status == "enabled") {
        this.props.history.push(`/campaigns?${Constants.DEFAULT_PAGINATION}`);
      } else {
        this.setState({ showStatusUpdating: false, showStatusNotReady: true });
      }
    });
  }

  showConfigureButton() {
    const { company } = this.props;
    const status = company.data.status;
    if (company.data.next_action != "") {
      return (
        <Button
          className="btn-success ns_configure_btn"
          onClick={this.configure.bind(this)}
        >
          {company.data.next_action}
        </Button>
      );
    }
  }

  showConfiguration() {
    const { company, registrar } = this.props;
    const status = company.data.status;
    if (status == "using_other_nameservers" && registrar) {
      return (
        <div>
          {this.showNSVideoForRegistrar(registrar.data)}
          {this.showConfigureButton()}
        </div>
      );
    } else if (company.data.next_action != "") {
      return <div>{this.showConfigureButton()}</div>;
    }
  }

  showRGNameservers() {
    return (
      <div>
        <h4>New Nameservers</h4>
        <ul>
          <li> ns1.rgnameserver.com </li>
          <li> ns2.rgnameserver.com </li>
          <li> ns3.rgnameserver.com </li>
          <li> ns4.rgnameserver.com </li>
        </ul>
      </div>
    );
  }

  showNSVideoForRegistrar(registrar) {
    if (
      registrar.url == "http://www.godaddy.com" ||
      registrar.name.toUpperCase() == "GoDaddy.com, LLC"
    ) {
      return (
        <div>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/18dMLAi62bM"
            frameBorder="0"
            allowFullScreen
          />
          <div>
            {" "}
            <a
              href="https://www.godaddy.com/help/set-custom-nameservers-for-domains-registered-with-godaddy-12317"
              className="m-t-10 btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              How to change your nameservers at GoDaddy
            </a>{" "}
          </div>
          {this.showRGNameservers()}
          <div>
            {" "}
            <a
              href="https://www.godaddy.com/"
              className="btn btn-primary change_ns_btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              1. First, change your nameservers at GoDaddy{" "}
            </a>{" "}
          </div>
        </div>
      );
    } else if (registrar.name.toUpperCase() == "ENOM, INC.") {
      return (
        <div>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/3rBB7qXr7JM"
            frameBorder="0"
            allowFullScreen
          />
          <div>
            {" "}
            <a
              href="http://www.enom.com/kb/kb/kb_0086_how-to-change-dns.htm"
              className="m-t-10 btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              How to change your nameservers at Enom
            </a>{" "}
          </div>
          {this.showRGNameservers()}
          <div>
            {" "}
            <a
              href="http://www.enom.com/"
              className="btn btn-primary change_ns_btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              1. Change your nameservers at Enom{" "}
            </a>{" "}
          </div>
        </div>
      );
    } else if (registrar.name.toUpperCase() == "NETWORK SOLUTIONS, LLC.") {
      return (
        <div>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/44N6s9q6NY8"
            frameBorder="0"
            allowFullScreen
          />
          <div>
            {" "}
            <a
              href="http://www.networksolutions.com/support/move-dns-to-a-new-server/"
              className="m-t-10 btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              How to change your nameservers at Network Solutions
            </a>{" "}
          </div>
          {this.showRGNameservers()}
          <div>
            {" "}
            <a
              href="http://www.networksolutions.com/"
              className="btn btn-primary change_ns_btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              1. Change your nameservers at Network Solutions{" "}
            </a>{" "}
          </div>
        </div>
      );
    } else if (registrar.name.toUpperCase() == "FASTDOMAIN, INC.") {
      return (
        <div>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/GsmBjBDahQc"
            frameBorder="0"
            allowFullScreen
          />
          <div>
            {" "}
            <a
              href="https://my.fastdomain.com/cgi/help/222"
              className="m-t-10 btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              How to change your nameservers at Fast Domain
            </a>{" "}
          </div>
          {this.showRGNameservers()}
          <div>
            {" "}
            <a
              href="https://my.fastdomain.com"
              className="btn btn-primary change_ns_btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              1. Change your nameservers at Fast Domain{" "}
            </a>{" "}
          </div>
        </div>
      );
    } else if (registrar.name.toUpperCase() == "NAME.COM, INC.") {
      return (
        <div>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/hF3ypSSQJaI"
            frameBorder="0"
            allowFullScreen
          />
          <div>
            {" "}
            <a
              href="https://www.name.com/support/articles/205934547-Changing-nameservers-for-DNS-management"
              className="m-t-10 btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              How to change your nameservers at Name.com
            </a>{" "}
          </div>
          {this.showRGNameservers()}
          <div>
            {" "}
            <a
              href="https://www.name.com"
              className="btn btn-primary change_ns_btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              1. Change your nameservers at Name.com{" "}
            </a>{" "}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          {this.showRGNameservers()}
          <div className="btn btn-primary change_ns_btn">
            {" "}
            1. Change your nameservers at your Domain Registrar{" "}
          </div>
        </div>
      );
    }
  }

  render() {
    const { company } = this.props;

    // Do not show if we have not loaded the data or the status is already enabled
    if (!company || !company.data || company.data.status == "enabled") {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }

    if (this.state && this.state.showStatusUpdating) {
      return (
        <div>
          <div className="alert alert-info">
            <strong>Configuration Updating: </strong>
            The configuration is updating ...
          </div>
          <div className="vertical-center">
            <CSSTransitionGroup
              transitionName="spinner"
              transitionAppear={true}
              transitionAppearTimeout={500}
            >
              <i className="fa fa-refresh fa-4x fa-spin" />
            </CSSTransitionGroup>
          </div>
        </div>
      );
    }

    if (this.state && this.state.showStatusNotReady) {
      return (
        <div>
          <div className="alert alert-success">
            <strong>Configuration is under way</strong>
          </div>
          <div className="well">
            <p>
              This may take as little as an hour but as long as 48 hours because
              your domain name servers have changed. Please check back later.
            </p>
            <p>
              In the meantime, you can learn more about the Drip and eBlast
              features in the video below.
            </p>
          </div>
          <div className="vertical-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/ziJw3YsP_YY"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>
      );
    }

    return (
      <div className="m-t-20">
        <div className="alert alert-success">
          <h4 className="dns-change-required">
            <strong>You&#39;re Almost There! </strong>
            <span dangerouslySetInnerHTML={{__html: this.props.company.data.status_message}} />
          </h4>
        </div>
        <div className="ns-help-container">{this.showConfiguration()}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    company: state.company.company,
    registrar: state.company.registrar
  };
}

export default connect(
  mapStateToProps,
  { fetchCompany, postCompanyConfigure, fetchCompanyRegistrar }
)(CompanyStatus);
